import update from 'immutability-helper';

import { REQUEST_ERROR, REQUEST_INPROGRESS, REQUEST_SUCCESS } from 'store/constants';

import {
  CATALOG_PRODUCTS_READY_TO_SWITCH,
  REQUEST_CATALOG_PRODUCTS,
  REQUEST_CATALOG_PRODUCTS_ERROR,
  REQUEST_CATALOG_PRODUCTS_SUCCESS,
  REQUEST_CATALOG_SHOW_MORE_LOADING,
  REQUEST_CATALOG_PRODUCT_OFFICES,
  REQUEST_CATALOG_PRODUCT_OFFICES_ERROR,
  REQUEST_CATALOG_PRODUCT_OFFICES_SUCCESS,
  REQUEST_CATALOG_PRODUCTS_APPLY,
  SUBSCRIBED_PRODUCT,
  SET_IS_FAVORITE_PRODUCTS,
} from '../constants';

const initialState = {
  list: [],
  updateRequestStatus: null,
  updateReadyToSwitch: false,
  showMoreLoading: false,
  paging: {
    perPage: 24,
    currentPage: 1,
    totalCount: 0,
  },
};

export default function (state = initialState, action = {}) {
  switch (action.type) {
    case REQUEST_CATALOG_PRODUCTS: {
      return {
        ...state,
        updateRequestStatus: REQUEST_INPROGRESS,
        updateReadyToSwitch: false,
      };
    }
    case REQUEST_CATALOG_PRODUCTS_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        updateRequestStatus: REQUEST_SUCCESS,
        /**
         * we store response data for later application
         * to make sure that our preloader is ready
         */
        updateResponseData: payload,
      };
    }
    case REQUEST_CATALOG_SHOW_MORE_LOADING: {
      const { payload } = action;
      return {
        ...state,
        showMoreLoading: payload,
      };
    }
    case REQUEST_CATALOG_PRODUCTS_ERROR: {
      const { errorType } = action;
      return {
        ...state,
        updateRequestStatus: REQUEST_ERROR,
        updateRequestErrorType: errorType,
      };
    }
    case REQUEST_CATALOG_PRODUCTS_APPLY: {
      const { list, paging } = action;
      return {
        ...state,
        list,
        paging,
      };
    }
    case CATALOG_PRODUCTS_READY_TO_SWITCH: {
      return {
        ...state,
        updateReadyToSwitch: true,
      };
    }
    case REQUEST_CATALOG_PRODUCT_OFFICES: {
      return {
        ...state,
        updateOfficesRequestStatus: REQUEST_INPROGRESS,
      };
    }
    case REQUEST_CATALOG_PRODUCT_OFFICES_ERROR: {
      return {
        ...state,
        updateOfficesRequestStatus: REQUEST_ERROR,
      };
    }
    case REQUEST_CATALOG_PRODUCT_OFFICES_SUCCESS: {
      const { points, requestData } = action;
      const { productId } = requestData;
      const { list } = state;
      const productIndex = list.findIndex(({ id }) => id === productId);
      if (productIndex !== -1) {
        return update(state, {
          updateOfficesRequestStatus: { $set: REQUEST_SUCCESS },
          list: {
            [productIndex]: {
              offices: { $set: points },
            },
          },
        });
      }
      return state;
    }
    case SUBSCRIBED_PRODUCT: {
      const { productId, text, emoji, className } = action;
      return {
        ...state,
        list: state.list.map((item) =>
          item.id === productId ?
            {
              ...item,
              outOfStockMessageTemplate: text,
              emoji,
              className,
            }
          : item,
        ),
      };
    }
    case SET_IS_FAVORITE_PRODUCTS: {
      const devices = [...state.list];
      const favoriteDevices = [...action.payload];

      const list = devices.map((device) => ({
        ...device,
        isFavorite: favoriteDevices.includes(device.id),
      }));

      return {
        ...state,
        list,
      };
    }
    default:
      return state;
  }
}
